import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { inFlightAtom } from './topProgressAtom';

export function TopProgressBar() {
  const active = useAtomValue(inFlightAtom) > 0;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (active) { setVisible(true); return; }
    const t = setTimeout(() => setVisible(false), 280);
    return () => clearTimeout(t);
  }, [active]);

  if (!visible) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[1100] h-[2px] overflow-hidden" aria-hidden style={{ opacity: active ? 1 : 0, transition: 'opacity 280ms ease' }}>
      <div className="h-full w-full sc-topbar-indet" style={{ background: 'linear-gradient(90deg, transparent, var(--sc-cyan), var(--sc-purple), transparent)', boxShadow: '0 0 8px rgba(0,255,209,0.6)' }} />
    </div>
  );
}
